// modules/DisplayLotRow.js
import React       from 'react';
import Clr         from './Clr';
import ViewButton  from './ViewButton';
import FormatPrice from './FormatPrice';
import PackageRender from './PackageRender';


class DisplayLotRow extends React.Component {

	render() {
		let frontage = '';
		switch(this.props.lot.type) {
			case 'Corner Lot':
				frontage = 'Cnr';
				break;
			case 'Irregular Lot':
				frontage = 'Irregular';
				break;
			default:
				frontage = this.props.lot.frontage + 'm';
		}
		return (
			<div className="lfss-resultrow">
				<div className="lfss-result-name">
					Lot {this.props.lot.name}
				</div>
				<div className="lfss-result-stage">
					{this.props.lot.stage_name}
				</div>
				<div className="lfss-result-price">
					<FormatPrice price={this.props.lot.price} sprice={this.props.lot.sprice} lot={this.props.lot}></FormatPrice>
				</div>
				<div className="lfss-result-area">
					{this.props.lot.area}m<sup>2</sup>
				</div>
				<div className="lfss-result-frontage">
					<div style={{display: "inline"}}>{frontage}</div>
				</div>
				<div className="lfss-result-packages">
					<PackageRender packages={this.props.lot.packages}></PackageRender>
				</div>
				<div className="lfss-result-view">
					<ViewButton lot={this.props.lot} stage={this.props.lot.stageslug}>View Lot</ViewButton>
				</div>
				<Clr />
			</div>
		);
	}
}

export default DisplayLotRow;


/** WEBPACK FOOTER **
 ** ./src/modules/common/DisplayLotRow.js
 **/